import React from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { Button } from "./ui/button";

export const EntryScreen = () => {
  const navigate = useNavigate();
  const { lang } = useLanguage();

  return (
    <div className="relative min-h-screen overflow-hidden bg-slate-900 text-slate-50">
      {/* SFONDO A TUTTO SCHERMO */}
      <div className="absolute inset-0">
        <img loading="lazy"
          src="/images/rosablu/gallery/paesaggio7.webp"
          alt={
            lang === "it"
              ? "Panorama invernale della Val di Sole"
              : "Winter landscape of Val di Sole"
          }
          className="h-full w-full object-cover"
        />
        {/* velo quasi trasparente per far vedere bene la foto */}
        <div className="absolute inset-0 bg-black/0" />
      </div>

      {/* CONTENUTO CENTRALE */}
      <div className="relative flex min-h-screen items-center justify-center px-4 py-8 md:px-6">
        {/* CARD CENTRALE: altezza ridotta, meno spazio sopra il logo */}
        <div className="section-fade-in mx-auto flex w-full max-w-[320px] flex-col items-center rounded-3xl bg-black/5 px-5 pt-1 pb-3 text-center shadow-lg backdrop-blur-sm md:max-w-[380px] md:px-8 md:pt-2 md:pb-4">
          {/* Logo */}
          <img loading="lazy"
            src="/images/rosablu/logo/logo.png"
            alt="Logo Rosa Blu Apartment"
            className="mb-0 h-36 w-auto md:h-48"
            style={{ filter: "invert(1) brightness(1.2)" }}
          />

          {/* Testi: blocco compatto subito sotto il logo */}
          <div className="mt-0.5 mb-3 flex flex-col items-center gap-[2px] md:gap-[3px]">
            <p className="text-xs font-semibold uppercase tracking-[0.28em] text-white drop-shadow-[0_0_10px_rgba(0,0,0,0.9)]">
              VAL DI SOLE · PIANO DI COMMEZZADURA
            </p>
            <h1 className="font-serif text-3xl leading-tight text-white drop-shadow-[0_0_14px_rgba(0,0,0,1)] md:text-4xl">
              ROSA BLU APARTMENT
            </h1>
            <p className="max-w-md text-sm leading-relaxed text-slate-50 drop-shadow-[0_0_12px_rgba(0,0,0,0.95)] md:text-base">
              {lang === "it"
                ? "Un appartamento curato nel cuore della Val di Sole, tra montagne, neve d'inverno e verdi prati d'estate."
                : "A curated apartment in the heart of Val di Sole, between snowy winters and green summer meadows."}
            </p>
          </div>

          {/* Bottone */}
          <Button
            className="rounded-full bg-[#b07157] px-8 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-white shadow-md hover:bg-[#975b45]"
            onClick={() => navigate("/home")}
          >
            {lang === "it" ? "Entra nel sito" : "Enter the website"}
          </Button>
        </div>
      </div>
    </div>
  );
};
